import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';

@Component({
  selector: 'app-question-buttons',
  templateUrl: './question-buttons.component.html',
  styleUrls: ['./question-buttons.component.scss']
})
export class QuestionButtonsComponent implements OnInit {

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService
  ) { }

  ngOnInit() {
  }

  
}